import React, { Component, PropTypes } from 'react';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchSalesChannel, fetchSettings, fetchGlobalSettings } from '../actions/';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import ViewSalesChannel from '../components/salesChannels/ViewSalesChannel';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  salesChannel: PropTypes.any,
  settings: PropTypes.any,
  globalSettings: PropTypes.any,
  salesChannelId: PropTypes.string.isRequired,
  query: PropTypes.object,
};

class SalesChannelViewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertOpen: false,
      alertMessage: '',
      edited: false,
      error: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.push('/');
    }
  }
  componentDidMount() {
    this.props.dispatch(fetchSalesChannel(this.props.salesChannelId));
    this.props.dispatch(fetchSettings(this.props.salesChannelId));
    this.props.dispatch(fetchGlobalSettings());
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="sales-channels component" style={authPage}>
        <ViewSalesChannel
          salesChannel={this.props.salesChannel}
          settings={this.props.settings}
          globalSettings={this.props.globalSettings}
        />
      </div>
    );
  }
}

SalesChannelViewPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

SalesChannelViewPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    salesChannel: state.salesChannels.salesChannel,
    salesChannelId: ownProps.params.id,
    error: state.salesChannels.error,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(SalesChannelViewPage));



// WEBPACK FOOTER //
// ./src/containers/SalesChannelViewPage.js